var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.072,9.41l-1.615-3.236c-.284-.568-.864-.927-1.5-.927h-7.913c-.635,0-1.216.359-1.5.927l-1.615,3.236c-.258.517-.393,1.087-.393,1.665v6.299c0,.762.617,1.379,1.379,1.379s1.379-.617,1.379-1.379v-.389h9.412v.389c0,.762.617,1.379,1.379,1.379s1.379-.617,1.379-1.379v-6.299c0-.578-.134-1.148-.393-1.665ZM6.623,8.88l.937-1.724c.139-.255.406-.414.697-.414h7.486c.291,0,.558.159.697.414l.937,1.724c.287.529-.095,1.172-.697,1.172H7.32c-.602,0-.984-.643-.697-1.172ZM7.855,15.239c-.734,0-1.329-.595-1.329-1.329s.595-1.329,1.329-1.329,1.329.595,1.329,1.329-.595,1.329-1.329,1.329ZM16.145,15.239c-.734,0-1.329-.595-1.329-1.329s.595-1.329,1.329-1.329,1.329.595,1.329,1.329-.595,1.329-1.329,1.329Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapCar);
export default __webpack_public_path__ + "static/media/map-car.3f0bb3d85db1f1c1406759a006740d69.svg";
export { ForwardRef as ReactComponent };